import { NgModule } from "@angular/core";
import { TradableToViewModule } from "../tradable-to-view-item/tradable-to-view.module";
import { CoreModule } from "../../../core/core.module";
import { FiatDepositSummaryComponent } from "./fiat-transactions/fiat-deposit-summary-modal/fiat-deposit-summary-modal.component";
import { FiatDepositModalComponent } from "./fiat-transactions/fiat-deposit-modal/fiat-deposit-modal.component";
import { FiatSendModalComponent } from "./fiat-transactions/fiat-withdraw-modal/fiat-send-modal/fiat-send-modal.component";
import { FiatWithdrawSummaryComponent } from "./fiat-transactions/fiat-withdraw-summary-modal/fiat-withdraw-summary.component";
import { FiatWithdrawalModalComponent } from "./fiat-transactions/fiat-withdraw-modal/fiat-withdraw-modal.component";
import { SendSummaryComponent } from "./sending-modal/send-summary/send-summary.component";
import { SendModalComponent } from "./sending-modal/send-modal/send-modal.component";
import { EidVerificationRedirectComponent } from "./success-screens/eid-verification-redirect/eid-verification-redirect.component";
import { FiatWithdrawalFraudComponent } from "./success-screens/fiat-withdraw-fraud/fiat-withdrawal-fraud.component";
import { SavingsFailedComponent } from "./success-screens/savings-failed/savings-failed.component";
import { SavingsSuccessComponent } from "./success-screens/savings-success/savings-success.component";
import { SwapSuccessComponent } from "./success-screens/swap-success/swap-success.component";
import { VerificationRedirectComponent } from "./success-screens/verification-redirect/verification-redirect.component";
import { TransferModalComponent } from "./transfer-modal/transfer-modal.component";
import { TilesModule } from "../tiles/tiles.module";
import { PayoutModule } from "../payout/payout.module";
import { PasswordValidationModule } from "../password-validation/password-validation.module";
import { Security2faModule } from "../../../shared/modals/security-2fa-modal/security-2fa.module";
import { StocksModule } from "../stocks/stocks.module";
import { FilterModule } from "../filters/filter.module";
import { ContactModule } from "../contact/contact.module";
import { VerificationCommonModule } from "../verification-common/verification-common.module";
import { TradePendingComponent } from "./success-screens/trade-pending/trade-pending.component";
import { TradeSwapPendingComponent } from "./success-screens/trade-swap-pending/trade-swap-pending.component";
import { WithdrawPendingComponent } from "./success-screens/withdraw-pending/withdraw-pending.component";
import { FiatTransactionSuccessComponent } from "./success-screens/fiat-transaction-success/fiat-transaction-success.component";
import { TradeSuccessComponent } from "./success-screens/trade-success/trade-success.component";
import { TradeSuccessV1Component } from "./success-screens/trade-success/trade-success-redesign/trade-success-redesign.component";
import { SuccessScreenComponent } from "./success-screens/success-screen.component";
import { SendSuccessComponent } from "./success-screens/send-success/send-success.component";
import { SendWaitingComponent } from "./success-screens/send-waiting/send-waiting.component";
import { SummaryGridModule } from "@modules/main/components/step-summary/summary-grid/summary-grid.module";
import { TranslationPipeModule } from "@modules/core/pipes/translation-pipe/translation-pipe.module";
import { PaysafeFlowModule } from "../../../paysafe/paysafe-flow.module";
import { CardDepositPendingComponent } from "./success-screens/card-deposit-pending/card-deposit-pending.component";
import { CardDepositTimeoutComponent } from "./success-screens/card-deposit-timeout/card-deposit-timeout.component";
import { DepositFailedComponent } from "@modules/main/components/step-summary/success-screens/deposit-end-screens/deposit-failed/deposit-failed.component";
import { DepositSuccessComponent } from "@modules/main/components/step-summary/success-screens/deposit-end-screens/deposit-success/deposit-success.component";
import { DepositCommonEndScreenComponent } from "@modules/main/components/step-summary/success-screens/deposit-end-screens/deposit-common-end-screen/deposit-common-end-screen.component";
import { DepositPendingComponent } from "@modules/main/components/step-summary/success-screens/deposit-pending/deposit-pending.component";
import { DepositErrorComponent } from "./success-screens/deposit-end-screens/deposit-error/deposit-error.component";
import { DepositSurveyModule } from "@modules/+new/payments/features/deposit-survey/deposit-survey.module";
import { InstantTradeBonusModule } from "@modules/shared/components/instant-trade-bonus/instant-trade-bonus.module";
import { WithdrawSuccessComponent } from "./success-screens/withdraw-success/withdraw-success.component";
import { DepositExpiredComponent } from "./success-screens/deposit-end-screens/deposit-expired/deposit-expired.component";
import { SwapSuccessV1Component } from "@modules/main/components/step-summary/success-screens/swap-success/swap-success-redesign/swap-success-redesign.component";
import { SocialTradingModule } from "@modules/social-trading/social-trading.module";
import { KycModule } from "@modules/kyc/kyc.module";
import { EntryDepositModule } from "@modules/+new/payments/features/entry-deposit/entry-deposit-module";
import { AddRecipientAddressComponent } from "@modules/main/components/step-summary/sending-modal/sending-recipient/add-recipient-address/add-recipient-address.component";
import { SendingRecipientComponent } from "@modules/main/components/step-summary/sending-modal/sending-recipient/sending-recipient.component";
import { SelectContactComponent } from "@modules/main/components/step-summary/sending-modal/sending-recipient/select-contact/select-contact.component";
import { RecentlyUsedRecipientsComponent } from "@modules/main/components/step-summary/sending-modal/sending-recipient/recently-used-recipients/recently-used-recipients.component";
import { CryptoDepositModule } from "@modules/+new/payments/features/crypto-deposit/crypto-deposit.module";
import { TaxSuccessAmountLabelModule } from "@modules/taxes/domain/ui/tax-success-amount-label/tax-success-amount-label.module";
import { SendSelectNetworkComponent } from "./sending-modal/send-select-network/send-select-network.component";
import { SendMultipleWalletsSelectionComponent } from "./sending-modal/send-multiple-wallets-selection/send-multiple-wallets-selection.component";
import { SendWarningComponent } from "./sending-modal/send-warning/send-warning.component";
import { SendSelectRecipientComponent } from "./sending-modal/send-select-recipient/send-select-recipient.component";
import { FieldContactItemComponent } from "./sending-modal/send-select-recipient/field-contact-item/field-contact-item/field-contact-item.component";
import { SendAmountComponent } from "@modules/main/components/step-summary/sending-modal/send-amount/send-amount.component";
import { SendMultichainSummaryComponent } from "./sending-modal/send-multichain-summary/send-multichain-summary.component";
import { SendMultichainTwoFaComponent } from "./sending-modal/send-multichain-two-fa/send-multichain-two-fa.component";
import { SendMultichainMoneyOnWayComponent } from "./success-screens/send-multichain-money-on-way/send-multichain-money-on-way.component";
import { LottieComponent } from "ngx-lottie";
import { SendScamWarningComponent } from "./sending-modal/send-scam-warning/send-scam-warning.component";
import { AddressBookWalletsListComponent } from "@modules/main/components/address-book-wallet/address-book-wallets-list/address-book-wallets-list.component";
import { MoSuccessVisionComponentComponent } from "@modules/web3/components/mo-success-vision-component/mo-success-vision-component.component";
import { IdentityVerificationRedirectComponent } from "@modules/main/components/step-summary/success-screens/identity-verification-redirect/identity-verification-redirect.component";
import { UKBusinessUserSelectorComponent } from "./sending-modal/uk-business-user-selector/uk-business-user-selector.component";
import { VerifyPayeeService } from "./fiat-transactions/services/verify-payee.service";

const components = [
	// Fiat transactions
	FiatDepositModalComponent,
	FiatDepositSummaryComponent,
	FiatSendModalComponent,
	FiatWithdrawalModalComponent,
	FiatWithdrawSummaryComponent,

	// Send
	SendSummaryComponent,
	SendModalComponent,
	AddRecipientAddressComponent,
	SelectContactComponent,
	SendingRecipientComponent,
	RecentlyUsedRecipientsComponent,

	// Success screens
	DepositFailedComponent,
	DepositPendingComponent,
	EidVerificationRedirectComponent,
	FiatTransactionSuccessComponent,
	FiatWithdrawalFraudComponent,
	SavingsFailedComponent,
	SavingsSuccessComponent,
	SendSuccessComponent,
	SendWaitingComponent,
	SwapSuccessComponent,
	SwapSuccessV1Component,
	TradeSuccessComponent,
	TradeSuccessV1Component,
	VerificationRedirectComponent,
	IdentityVerificationRedirectComponent,
	WithdrawPendingComponent,
	SuccessScreenComponent,
	TradePendingComponent,
	TradeSwapPendingComponent,
	CardDepositPendingComponent,
	CardDepositTimeoutComponent,
	DepositSuccessComponent,
	DepositCommonEndScreenComponent,
	WithdrawSuccessComponent,

	// Transfer
	TransferModalComponent,

	DepositErrorComponent,
	DepositExpiredComponent
];

@NgModule({
	imports: [
		CoreModule,
		TradableToViewModule,
		TilesModule,
		VerificationCommonModule,
		PayoutModule,
		PasswordValidationModule,
		Security2faModule,
		StocksModule,
		KycModule,
		FilterModule,
		ContactModule,
		DepositSurveyModule,
		// Summary grid
		SummaryGridModule,
		TranslationPipeModule,
		PaysafeFlowModule,
		InstantTradeBonusModule,
		SocialTradingModule,
		EntryDepositModule,
		CryptoDepositModule,
		TaxSuccessAmountLabelModule,
		LottieComponent,
		AddressBookWalletsListComponent,
		MoSuccessVisionComponentComponent
	],
	declarations: [
		...components,
		SendSelectNetworkComponent,
		SendMultipleWalletsSelectionComponent,
		SendWarningComponent,
		SendSelectRecipientComponent,
		FieldContactItemComponent,
		SendAmountComponent,
		SendMultichainSummaryComponent,
		SendMultichainTwoFaComponent,
		SendMultichainMoneyOnWayComponent,
		SendScamWarningComponent,
		SendScamWarningComponent,
		UKBusinessUserSelectorComponent
	],
	providers: [VerifyPayeeService],
	exports: [...components, SummaryGridModule]
})
export class StepSummaryModule {}
